export function arrivageRequest(state={
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_ARRIVAGE_START":           
        case "UPDATE_ARRIVAGE_START":           
        case "RECEIVE_ARRIVAGE_START":           
        case "DELETE_ARRIVAGE_START":           
        case "FETCH_INIT_DATA2_START":           
        case "FETCH_INIT_DATA3_START":           
            return {
                ...state, 
                fetching:true
            }        
        case "CREATE_ARRIVAGE_FULFILLED":           
        case "UPDATE_ARRIVAGE_FULFILLED":           
        case "RECEIVE_ARRIVAGE_FULFILLED":           
        case "DELETE_ARRIVAGE_FULFILLED":           
        case "FETCH_INIT_DATA3_FULFILLED":           
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_ARRIVAGE_ERROR":
        case "UPDATE_ARRIVAGE_ERROR":
        case "RECEIVE_ARRIVAGE_ERROR":
        case "DELETE_ARRIVAGE_ERROR":
        case "FETCH_INIT_DATA3_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}